import { HospitalPayload } from '_api/types';
import { US_STATES } from '_constants';
import { CheckboxField, InputField, SelectField } from 'components/molecules/formFields';
import React from 'react';
import { useOrganizations, useUser } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { FormField } from './form-builder/types';
import { BaseFormProps } from './types';

export const HospitalForm = ({
  disableAll = false,
  hideSubmitButtons = false,
  initValue,
  onBack,
  onSubmit,
}: BaseFormProps<HospitalPayload>) => {
  const { organizationOptions } = useOrganizations();
  const { isSuperAdmin, isOrgAdmin } = useUser();

  const fields = [
    {
      component: InputField,
      fieldKey: 'name',
      label: 'Name',
      required: true,
      xs: isSuperAdmin || isOrgAdmin ? 4 : 6,
    },
    isSuperAdmin
      ? {
          component: SelectField,
          fieldKey: 'organizationId',
          label: 'Organization',
          options: organizationOptions,
          required: true,
          xs: 4,
        }
      : null,
    {
      component: InputField,
      fieldKey: 'phoneNumber',
      label: 'Phone Number',
      required: true,
      type: 'number',
      mask: '(000) 000-0000',
      xs: isSuperAdmin || isOrgAdmin ? 4 : 6,
    },
    {
      component: InputField,
      fieldKey: 'streetAddress',
      label: 'Street Address',
      required: true,
      xs: 4,
    },
    {
      component: InputField,
      fieldKey: 'city',
      label: 'City',
      required: true,
      xs: 4,
    },
    {
      component: SelectField,
      fieldKey: 'state',
      label: 'State',
      options: US_STATES.map((state) => ({
        description: state,
        name: state,
      })),
      required: true,
      xs: 2,
    },
    {
      component: InputField,
      fieldKey: 'zipCode',
      label: 'Zip Code',
      required: true,
      xs: 2,
    },
    {
      component: CheckboxField,
      fieldKey: 'canGuardianContactTherapist',
      label: 'Messaging',
      checkboxLabel: 'Allow guardians to contact therapists through the app',
      xs: 12,
      labelCss: {
        fontSize: 23,
        color: 'black',
        fontWeight: 'bold',
        paddingTop: '30px',
      },
    },
  ];

  const getFormFields = (): FormField[] => {
    return fields.reduce((a: FormField[], f: FormField | null) => {
      if (f != null) {
        a.push(f);
      }
      return a;
    }, []);
  };

  return (
    <FormBuilder
      disabled={disableAll}
      initValues={initValue}
      formFields={getFormFields()}
      onBack={onBack}
      onSubmit={onSubmit}
      hideSubmit={hideSubmitButtons}
    />
  );
};
